import spells from '../../../data/spells';

export const isReactionCastingTime = (value) => typeof value === 'string'
  && (/(^|\b)(?:1|one|a)\s+reaction\b/i.test(value.trim()) || /^reaction\b/i.test(value.trim()));

export const reactionSpells = Object.entries(spells)
  .filter(([, spell]) => isReactionCastingTime(spell.castingTime))
  .map(([id, spell]) => ({ id, ...spell }))
  .sort((a, b) => a.name.localeCompare(b.name));

export const filterReactionSpells = (query, catalog = reactionSpells) => {
  const needle = String(query || '').trim().toLowerCase();
  if (!needle) return catalog;
  return catalog.filter((spell) => [spell.name, spell.school, spell.description, spell.castingTrigger]
    .some((value) => String(value || '').toLowerCase().includes(needle)));
};

export const formatComponents = (spell) => {
  const components = (spell.components || []).map((component) => String(component).toUpperCase()).join(', ');
  return spell.material ? `${components} (${spell.material})` : components || '—';
};

export const createReactionSpellEntry = (spell) => ({
  spellId: spell.id,
  name: spell.name,
  castingLevel: Number(spell.level),
  usage: { type: 'at_will' },
  spell: {
    name: spell.name, baseLevel: Number(spell.level), castingTime: spell.castingTime,
    castingTrigger: spell.castingTrigger || '', range: spell.range || '', components: spell.components || [],
    material: spell.material || '', duration: spell.duration || '', description: spell.description || '',
    higherLevels: spell.higherLevels || '',
  },
});

export const formatReactionSpellDescription = (entry) => {
  const { spell = {}, usage = {} } = entry;
  const details = [`Cast at level ${entry.castingLevel}`, spell.castingTrigger && `Trigger: ${spell.castingTrigger}`,
    usage.type === 'at_will' && 'At will', usage.type === 'per_day' && `${usage.uses}/day`,
    usage.type === 'spell_slot' && 'Expends a spell slot', entry.ability && `${entry.ability.toUpperCase()} spellcasting`,
    entry.saveDc !== undefined && `save DC ${entry.saveDc}`,
    entry.attackBonus !== undefined && `spell attack ${Number(entry.attackBonus) >= 0 ? '+' : ''}${entry.attackBonus}`,
  ].filter(Boolean).join('; ');
  return `${details}. ${spell.description || ''}${spell.higherLevels ? `\n\nUsing a Higher-Level Spell Slot: ${spell.higherLevels}` : ''}`;
};
